import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class UtilService {
    constructor(
        private router: Router,
        private location: Location
    ) {}

    removeUrlParamWithoutTriggeringNavigation(paramKey: string): void {
        const tree = this.router.parseUrl(this.router.url);
    
        if (tree.queryParams.hasOwnProperty(paramKey)) {
            delete tree.queryParams[paramKey];
        }
        const newUrl = this.router.serializeUrl(tree);
    
        this.location.replaceState(newUrl);
    }

    addUrlParamWithoutTriggeringNavigation(paramKey: string, paramValue: string): void {
        const tree = this.router.parseUrl(this.router.url);
        tree.queryParams[paramKey] = paramValue;
        const newUrl = this.router.serializeUrl(tree);
        this.location.replaceState(newUrl);
    }
}
